import styled from '@emotion/styled';
import { Card } from '@mui/material';
import { shouldForwardProps } from '../../../utils';
import { WhiteButton } from '../../../components';
import { HourglassBottom } from '@mui/icons-material';

const MatchingCard = styled(Card, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.secondaryDark};
    width: 100%;
    padding: ${({ theme }) => theme.spacing(3)};
    gap: ${({ theme }) => theme.spacing(2)};
    border-radius: 4px;
`;

const MatchingButton = styled(WhiteButton, shouldForwardProps)`
    width: fit-content;
    color: ${({ theme }) => theme.colors.onSurface};
`;

const NoMatchCard = styled(Card)`
    padding: ${({ theme }) => theme.spacing(3)};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    align-items: center;
`;

const Hourglass = styled(HourglassBottom)`
    height: 80px;
    width: 80px;
    color: ${({ theme }) => theme.colors.secondaryDark};
`;

export { MatchingCard, MatchingButton, NoMatchCard, Hourglass };
